import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const auditTrail = {
  namespaced: true,

  actions: {
    GetAllAuditTrail ({ rootState, dispatch }, { searchParams, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api
          .get(
            `/AuditTrail/GetAllAuditTrail?PageNumber=${searchParams.PageNumber}&PageSize=${searchParams.PageSize}&DateFrom=${searchParams.DateFrom}&DateTo=${searchParams.DateTo}&SearchValue=${searchParams.SearchValue}`,
            config
          )
          .then(response => response)
          .then(response => {
            rootState.loading = false
            resolve(response.data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetByMerchantAuditTrail ({ rootState, dispatch }, { searchParams, config }) {
      return new Promise((resolve, reject) => {
        rootState.loading = true

        api
          .get(
            `/AuditTrail/GetByMerchantAuditTrail?PageNumber=${searchParams.PageNumber}&PageSize=${searchParams.PageSize}&DateFrom=${searchParams.DateFrom}&DateTo=${searchParams.DateTo}&SearchValue=${searchParams.SearchValue}`,
            config
          )
          .then(response => response)
          .then(response => {
            rootState.loading = false
            resolve(response.data)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default auditTrail
